import Skeleton, { type SkeletonProps } from '@mui/material/Skeleton';

type Props = SkeletonProps & {
  rounded?: boolean;
};

export const ImageSkeleton = ({ rounded = true, ...props }: Props) => {
  return (
    <Skeleton
      variant="rectangular"
      width="100%"
      height="100%"
      sx={(theme) => {
        const numericRadius =
          typeof theme.shape.borderRadius === 'number'
            ? theme.shape.borderRadius
            : Number.parseFloat(theme.shape.borderRadius);
        const baseRadius = Number.isFinite(numericRadius) ? numericRadius : 0;

        return {
          aspectRatio: '1 / 1',
          borderRadius: rounded ? baseRadius / 2 : 0,
          display: 'block',
          height: 'auto',
        };
      }}
      {...props}
    />
  );
};

export const ImageSkeletonList = ({ count = 4 }: { count?: number }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <ImageSkeleton key={index} data-testid="image-skeleton" />
      ))}
    </>
  );
};
